import { gql } from '@apollo/client';
import CLINIC_TICKET_FRAGMENT from '../fragments/clinicTicketFragment';

const UPDATE_SUPPORT_REQUEST = gql`
  mutation updateSupportRequest($input: UpdateSupportRequestInput!) {
    updateSupportRequest(input: $input) {
      isSuccess
      message
      clinicTicket {
        ...ClinicTicketFragment
      }
    }
  }

  ${CLINIC_TICKET_FRAGMENT}
`;

export default UPDATE_SUPPORT_REQUEST;
